import React from "react";
import ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { IntercomProvider } from "react-use-intercom";
import App from "./App";
import theme from "./theme";

(function cleanUpCASTicket() {
  const url = new URL(window.location.href);
  const ticket = url.searchParams.get("ticket");

  if (ticket) {
    // Save for later validation
    localStorage.setItem("casTicket", ticket);

    // Remove from URL instantly (no page reload)
    url.searchParams.delete("ticket");
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }
})();

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);
const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_ID;

root.render(
  <IntercomProvider appId={INTERCOM_APP_ID || ""}>
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstarts an elegant, consistent, and simple baseline to build upon */}
      <CssBaseline />
      <App />
    </ThemeProvider>
  </IntercomProvider>
);